import { Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  private readonly IDLE_TIMEOUT_MS = 20 * 60 * 1000; // 20 minutos
  private idleSubscription: Subscription | null = null;
  private timerSubscription: Subscription | null = null;

  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly ngZone = inject(NgZone);

  startWatching(): void {
    if (this.idleSubscription) {
      return;
    }

    // Eventos que indican actividad del usuario
    const activityEvents$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click'),
      fromEvent(document, 'scroll')
    ).pipe(
      throttleTime(2000) // Procesar actividad a lo sumo cada 2 segundos para no ahogar la UI
    );

    // NgZone.runOutsideAngular para evitar disparar la detección de cambios continuamente
    this.ngZone.runOutsideAngular(() => {
      this.idleSubscription = activityEvents$.subscribe(() => {
        this.resetTimer();
      });
    });

    this.resetTimer();
  }

  stopWatching(): void {
    if (this.idleSubscription) {
      this.idleSubscription.unsubscribe();
      this.idleSubscription = null;
    }
    this.clearTimer();
  }

  private resetTimer(): void {
    this.clearTimer();

    this.ngZone.runOutsideAngular(() => {
      this.timerSubscription = timer(this.IDLE_TIMEOUT_MS).subscribe(() => {
        // Volver a la zona de Angular para realizar la navegación y actualización de estado
        this.ngZone.run(() => {
          this.handleIdleTimeout();
        });
      });
    });
  }

  private clearTimer(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }

  private handleIdleTimeout(): void {
    if (this.auth.isAuthenticated()) {
      console.info('[IDLE] El usuario ha estado inactivo por 20 minutos. (Auto-cierre de sesión deshabilitado por solicitud del usuario)');
      // this.auth.logout();
      // this.router.navigate(['/auth/login']);
      // this.stopWatching();
    }
  }
}
